import {
    FaHeartbeat,
    FaStethoscope,
    FaListUl,
    FaCashRegister
} from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import MonthlyUtilizationWrapper from './MonthlyUtilization';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import ItermidiateCareUnitWrapper from './IntermediateCareUnit';
import ValueWrapper from './Value';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Utilização - UTI',
        path: '/governanceroom/dashboardsihsus/uti/monthly-utilization',
        icon: <FaHeartbeat className="icon" />
    },
    {
        title: 'Utilização - Intermediária',
        path: '/governanceroom/dashboardsihsus/uti/intermediate-care-unit',
        icon: <FaStethoscope className="icon" />
    },
    {
        title: 'Tipos de Internação',
        path: '/governanceroom/dashboardsihsus/uti/type',
        icon: <FaListUl className="icon" />
    },
    {
        title: 'Valor - UTI',
        path: '/governanceroom/dashboardsihsus/uti/value',
        icon: <FaCashRegister className="icon" />
    }
];

const titleMap = {
    '/governanceroom/dashboardsihsus/uti/monthly-utilization':
        'Utilização Mensal',
    '/governanceroom/dashboardsihsus/uti/intermediate-care-unit':
        'Utilização - Intermediária',
    '/governanceroom/dashboardsihsus/uti/type': 'Tipos de Internação',
    '/governanceroom/dashboardsihsus/uti/value': 'Valor - UTI'
};

export const UTI = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="monthly-utilization"
                            element={<MonthlyUtilizationWrapper />}
                        />

                        <Route
                            path="intermediate-care-unit"
                            element={<ItermidiateCareUnitWrapper />}
                        />

                        <Route
                            path="/type"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'do Tipo de Internamento'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.UTI_TYPE,
                                        url: 'governanceroom/dashboard/sihsus/aih/utiTypes'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route path="value" element={<ValueWrapper />} />

                        <Route
                            path="/"
                            element={
                                <Navigate to="monthly-utilization" replace />
                            }
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
